<template>
</template>

<script>
    export default {
        created() {
            window.open('https://rcofkvbmsa.feishu.cn/wiki/DcCOwVuquibGc2k69wNc6DQDntb?from=from_copylink')
        }
    }
</script>